import styled from 'styled-components'

export const DashBoardContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  margin-top: 26px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`
